// export function getPathFromUrl(fullUrlString: string) {
//   try {
//     const url = new URL(fullUrlString);
//     // url.pathname gets the path (e.g., "/shop")
//     // url.search gets the entire query string (e.g., "?category=combo-zilqh")
//     return url.pathname + url.search;
//   } catch (error) {
//     console.error('Invalid URL provided:', error);
//     return null;
//   }
// }

export function getPathFromUrl(
  urlString: string | null | undefined
): string | null {
  // 1. Guard Clause: Handle null, undefined, or empty strings immediately.
  if (!urlString) {
    return null;
  }

  // 2. Optimization: If it's already a relative path, just return it.
  // This is the most common case for internal links.
  if (urlString.startsWith('/')) {
    return urlString;
  }

  // 3. If it might be a full URL, try to parse it.
  try {
    const url = new URL(urlString);
    // Return the path and any search parameters (e.g., "/shop?category=1")
    return url.pathname + url.search;
  } catch (error) {
    // 4. Fallback: If it's not a relative path and not a valid full URL,
    // it's a malformed string (e.g., "shop" without a slash).
    // Log the issue and return a safe value.
    console.warn(
      `Could not parse URL from string: "${urlString}". Returning null.`
    );
    return null; // Or return '#' as a safe fallback for links
  }
}
